module.exports = __webpack_public_path__ + "img/MM.43926920.svg";